import {
  LEGACY_PRODUCTION_TEAM,
  PRODUCTION_RESPONSIBLE_TEAM,
} from '../services/caseProductionPhasesService';
import { WORKSHOP_OPERATOR_PHASE_NAME_HINTS } from './workshopOperatorView';
import { isProductionManagerRole } from './operatorRoles';

export { LEGACY_PRODUCTION_TEAM };

const PRODUCTION_ATELIER_TEAMS = new Set([
  PRODUCTION_RESPONSIBLE_TEAM,
  LEGACY_PRODUCTION_TEAM,
]);

/**
 * Ordre de résolution : rôles les plus spécifiques en premier (évite « découpe » → 3D au lieu de finition).
 */
const PHASE_ROLE_RESOLUTION_ORDER = [
  'operator_finition',
  'operator_thermo',
  'operator_qualite',
  'livraison',
  'operator_3d',
];

function normalizePhaseName(name) {
  return String(name || '')
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '');
}

/**
 * Phases production atelier (groupe lot ≥ 2, équipe production).
 */
export function isProductionAtelierPhaseForAssignment({ group, responsible_team }) {
  const g = group == null || group === '' ? NaN : Number(group);
  if (!Number.isFinite(g) || g < 2) return false;
  const team = String(responsible_team ?? '').trim();
  return PRODUCTION_ATELIER_TEAMS.has(team);
}

/**
 * Sous-rôle opérateur éligible pour désigner le responsable (un seul match).
 * @returns {string|null} role_type ou null si ambiguïté / aucun match
 */
export function getEligibleOperatorRoleForPhaseName(phaseName) {
  const n = normalizePhaseName(phaseName);
  if (!n) return null;

  const matches = [];
  for (const roleType of PHASE_ROLE_RESOLUTION_ORDER) {
    const hints = WORKSHOP_OPERATOR_PHASE_NAME_HINTS[roleType];
    if (!hints?.length) continue;
    if (hints.some((h) => n.includes(h))) {
      matches.push(roleType);
    }
  }

  if (matches.length === 1) return matches[0];
  if (matches.length > 1) {
    return PHASE_ROLE_RESOLUTION_ORDER.find((r) => matches.includes(r)) ?? null;
  }
  return null;
}

export function userCanAssignProductionPhaseResponsible(userRole) {
  if (!userRole) return false;
  if (userRole === 'administrator') return true;
  return isProductionManagerRole(userRole);
}
